module.exports = __webpack_public_path__ + "img/no-list-close.243131e6.svg";